import Lenis from 'lenis'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export default function () {
  gsap.registerPlugin(ScrollTrigger)

  // Initialize a new Lenis instance for smooth scrolling
  const lenis = new Lenis()

  // Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
  lenis.on('scroll', ScrollTrigger.update)

  // Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
  // This ensures Lenis's smooth scroll animation updates on each GSAP tick
  gsap.ticker.add((time) => {
    lenis.raf(time * 1000) // Convert time from seconds to milliseconds
  })

  // Disable lag smoothing in GSAP to prevent any delay in scroll animations
  gsap.ticker.lagSmoothing(0)

  const pageTitle = document.querySelector('.PageTitle')
  const body = document.querySelector('body')

  const logo = () => {
    gsap.to(pageTitle, {
      yPercent: 50,
      ease: 'none',
      scrollTrigger: {
        trigger: pageTitle,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
      },
    })
  }

  logo()
}
